import { Box, Button, Stack, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from 'react-i18next';
import { OperationActionEnum } from '@/types/pricing';

interface OperationCardProps {
  /** Translation key for the operation name */
  nameKey: string;
  /** Optional plain-text provider name (not a translation key) */
  providerName?: string;
  id: number;
  onActionRequest: (action: OperationActionEnum, id: number) => void;
}

export function OperationCard({
  nameKey,
  providerName,
  id,
  onActionRequest,
}: OperationCardProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: 'background.paper',
      }}
    >
      <Box>
        <Typography variant="body2" fontWeight={500}>
          {t(nameKey, { defaultValue: nameKey })}
        </Typography>
        {providerName && (
          <Typography variant="caption" color="text.secondary">
            {providerName}
          </Typography>
        )}
      </Box>
      <Stack direction="row" spacing={1}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<EditIcon fontSize="small" />}
          onClick={() => onActionRequest(OperationActionEnum.EDIT, id)}
        >
          {t('global.edit', { defaultValue: 'Edit' })}
        </Button>
        <Button
          size="small"
          variant="outlined"
          startIcon={<VisibilityIcon fontSize="small" />}
          onClick={() => onActionRequest(OperationActionEnum.VIEW, id)}
        >
          {t('global.view', { defaultValue: 'View' })}
        </Button>
      </Stack>
    </Box>
  );
}
